module.exports = __webpack_public_path__ + "img/Posada-cabo_0003_hotel5.7aebdcc7.jpg";